export const defaultChangeUserPassword = {
    email: "",
    oldPassword: "",
    newPassword: "",
  };
  